export function isOnAuthRoute(): boolean {
  const { pathname } = window.location;
  return (
    pathname.startsWith('/login') ||
    pathname.startsWith('/client/login') ||
    pathname.startsWith('/client/register') ||
    pathname.startsWith('/client/forgot-password') ||
    pathname.startsWith('/forgot-password') ||
    pathname.startsWith('/reset-password') ||
    pathname.startsWith('/invite') ||
    // Partner sign-in + SSO landing. Without these a 401 fired on those pages
    // would replace() the location and loop.
    pathname.startsWith('/sso/') ||
    pathname.startsWith('/auth/sso/')
  );
}

/**
 * Append `?redirect=<current pathname+search>` so the login flow can land
 * the user back where they were. No-op when already on an auth route.
 */
export function buildLoginRedirect(destination: string): string {
  const { pathname, search } = window.location;
  if (isOnAuthRoute()) return destination;
  const attempted = encodeURIComponent(pathname + search);
  const sep = destination.includes('?') ? '&' : '?';
  return `${destination}${sep}redirect=${attempted}`;
}

/** The ?redirect= target if it resolves to this origin (so not '//host' or '/\host'), else null. */
export function readSafeRedirect(): string | null {
  const requested = new URLSearchParams(window.location.search).get('redirect');
  if (!requested?.startsWith('/')) return null;
  try {
    const target = new URL(requested, window.location.origin);
    const path = target.pathname + target.search + target.hash;
    // '/..//host' normalises to '//host', which the browser reads as another origin.
    if (target.origin !== window.location.origin || path.startsWith('//')) return null;
    return path;
  } catch {
    return null;
  }
}
